<template>
  <iRow wrap="nowrap" align="between" vertical-align="middle">
    <iColumn gap="none">
      <iText>
        {{ title }}
      </iText>
      <iText variant="subtle" font-size="small">
        {{ description }}
      </iText>
    </iColumn>
    <iColumn height="hug" width="hug">
      <iToggleSwitch :model-value="modelValue" @update:model-value="$emit('update:model-value', $event)" />
    </iColumn>
  </iRow>
</template>

<script>
export default {
  name: "NotificationToggle",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:model-value"],
};
</script>

<style scoped lang="scss">
</style>
